import { render, staticRenderFns } from "./SurveyResultDialog.vue?vue&type=template&id=1b75520b&scoped=true&"
import script from "./SurveyResultDialog.vue?vue&type=script&lang=ts&"
export * from "./SurveyResultDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyResultDialog.vue?vue&type=style&index=0&id=1b75520b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b75520b",
  null
  
)

export default component.exports